/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
    $('#header').toggleClass('active')
  })

  var showFlag = false
  var spBanner = $('.js-fix-footer')
  spBanner.css('bottom', '-100px')
  //スクロールが100に達したらボタン表示
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      if (showFlag === false) {
        showFlag = true
        spBanner.stop().animate(
          {
            bottom: '0'
          },
          400
        )
      }
    } else {
      if (showFlag) {
        showFlag = false
        spBanner.stop().animate(
          {
            bottom: '-100px'
          },
          400
        )
      }
    }
  })

  $('.js-slick').slick({
    // スライダー
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: false,
    // 自動再生。trueで自動再生される。
    autoplay: true,
    // 自動再生で切り替えをする時間
    autoplaySpeed: 6000,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 600,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: true,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'js-slick-dot',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: false,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: false,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: true,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false,
    // 表示中の画像を中央へ（左右スライドのチラ見せに使用）
    centerMode: true,
    // 中央のpadding（左右スライドのチラ見せに使用。レスポンシブを考えて%指定）
    centerPadding: '8.5%'
  })
})
